import { getIn, useFormikContext } from "formik";
import React from "react";
import { TextField } from "../components";
export const FormikTextField = (props) => {
    const formik = useFormikContext();
    const error = getIn(formik.errors, props.name);
    const handleBlur = () => {
        formik.setFieldTouched(props.name, true);
    };
    const touched = getIn(formik.touched, props.name);
    const _value = getIn(formik.values, props.name);
    return (React.createElement(TextField, Object.assign({ onChange: (e) => formik.setFieldValue(props.name, e === null || e === void 0 ? void 0 : e.target.value), value: _value, error: touched && !!error, errorText: touched ? error : "", onBlur: handleBlur }, props)));
};
//# sourceMappingURL=FormikTextField.js.map